import { Box, Card, Chip, Typography, useTheme } from "@mui/material";
import type { PimoReactComponent } from "@pimo/pimo-app-builder";

interface Badge {
  color: string;
  title: string;
  text: string;
  textColor?: string;
}

export interface MultipleBadgeCardV2Props {
  headlineText: string;
  headlineTextColor?: string;
  badges: Badge[];
  cardIcon?: string;
}

export const MultipleBadgeCardV2: PimoReactComponent<
  MultipleBadgeCardV2Props
> = ({ cardIcon, headlineText, badges }) => {
  const theme = useTheme();
  const gridwidth = Math.floor(12 / badges.length);
  return (
    <Card
      sx={{
        backgroundColor: theme.palette.primary.light,
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        p: 2,
        boxShadow: "none",
        gap: 2,
        "@media print": {
          border: "1px solid rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",

          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        {cardIcon && (
          <Box
            component="img"
            src={cardIcon}
            sx={{
              backgroundColor: "white",
              borderRadius: "12px",
              p: "5px",
              mr: 2,
              height: "36px",
              filter: "color: red",
            }}
          />
        )}
        <Typography
          variant="h5"
          sx={{
            color: theme.palette.primary.contrastText,
          }}
        >
          {headlineText}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexWrap="nowrap"
        sx={{
          marginTop: 2,
          overflowX: "auto",
          justifyContent: "space-between",
        }}
      >
        {badges.map((badge, index) => (
          <Box
            key={index}
            textAlign="center"
            sx={{ flex: "1 1 auto", marginRight: 1 }}
          >
            <Typography variant="subtitle2" sx={{ marginBottom: "4px" }}>
              {badge.title}
            </Typography>
            <Chip
              label={badge.text}
              sx={{
                backgroundColor: badge.color,
                color: badge.textColor,
                borderRadius: "6px",
                minWidth: gridwidth,
              }}
            />
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default MultipleBadgeCardV2;
